module.exports = __webpack_public_path__ + "static/iracing-hero-851642b3c31c2754d7fc1cab7ab56ceb.webm";